import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

/**
 * Downward arrow for the descending (Z-A) state of the sort controls.
 *
 * The glyph already points down, so the control cancels MUI's own icon
 * rotation instead of reusing the upward arrow.
 */
export function ArrowDownwardOutline(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 24 24'
    >
      <path
        d='M18.7698 13.36C18.6858 13.2587 18.5827 13.175 18.4664 13.1137C18.35 13.0523 18.2227 13.0145 18.0918 13.0025C17.9608 12.9904 17.8287 13.0043 17.7031 13.0433C17.5775 13.0824 17.4608 13.1458 17.3598 13.23L12.9998 16.86V5C12.9998 4.73478 12.8944 4.48043 12.7069 4.29289C12.5194 4.10536 12.265 4 11.9998 4C11.7346 4 11.4802 4.10536 11.2927 4.29289C11.1051 4.48043 10.9998 4.73478 10.9998 5V16.86L6.63978 13.23C6.53867 13.146 6.42198 13.0826 6.2964 13.0437C6.17082 13.0047 6.03879 12.9909 5.90786 13.003C5.77693 13.0151 5.64966 13.0528 5.53331 13.1141C5.41697 13.1753 5.31383 13.2589 5.22978 13.36C5.14574 13.4611 5.08243 13.5778 5.04348 13.7034C5.00453 13.829 4.99069 13.961 5.00276 14.0919C5.01484 14.2229 5.05258 14.3501 5.11384 14.4665C5.17509 14.5828 5.25867 14.686 5.35978 14.77L11.3598 19.77L11.5098 19.86L11.6398 19.93C11.8715 20.0194 12.1281 20.0194 12.3598 19.93L12.4898 19.86L12.6398 19.77L18.6398 14.77C18.741 14.6861 18.8247 14.583 18.8861 14.4666C18.9474 14.3503 18.9852 14.2229 18.9973 14.092C19.0094 13.961 18.9955 13.8289 18.9565 13.7033C18.9174 13.5777 18.854 13.461 18.7698 13.36Z'
        fill='currentColor'
      />
    </SvgIcon>
  );
}
